import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Peek from './peek';
import * as serviceWorker from './serviceWorker';
const el = document.querySelector('#peekaaii');
ReactDOM.render(<Peek myid={el.dataset.id} myurl={el.dataset.url}   myshow={el.dataset.show} />, document.getElementById('peekaaii'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
